import store from "../../../../../store";
import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_NUMBER: "array_number",
    ARRAY_STRING: "array_string",
    ARRAY_DATE: "array_date",
    ARRAY_OBJECT: "array_objectId",
    ARRAY_BOOLEAN: "array_boolean",
    OBJECT: "object",
    MIXED: "mixed",
};
const contexts = {
    CONTACT: "contact",
    CONVERSATION: "conversation",
    BLOCK: "block",
    EVENT: "event",
    WEBHOOK: "webhook",
    SYSTEM: "system",
    CUSTOM: "custom",
};
const defaultOperators = {
    string: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
    ],
    array: ["equal", "not_equal", "contains", "not_contains", "empty", "not_empty"],
    number: ["equal", "not_equal", "greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal"],
    boolean: ["equal", "not_equal", "empty", "not_empty"],
    date: [
        "equal",
        "not_equal",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
        "empty",
        "not_empty",
    ],
    ObjectId: ["equal", "not_equal", "empty", "not_empty"],
    object: ["equal", "not_equal", "empty", "not_empty"],
    mixed: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
    ],
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        name,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || defaultOperators[valueType] || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class ContactModuleAttributeFactory {
    /**
     *
     * @param parent {AutomationAttributesGenerator}
     */
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        const profileButtonClicked = this.profileButtonClicked();
        const adViewed = this.adViewed();

        return _.concat(profileButtonClicked, adViewed);
    }

    profileButtonClicked() {
        const e = AutomationEventTypes.CONTACT.PROFILE_BUTTON_CLICKED;
        const ga = this.parent.generateAttribute;

        const prefix = `event.${e}`;
        return [
            ga(contexts.EVENT, `${prefix}`, "Clicked Contact", vt.OBJECT, undefined, [
                ga(contexts.EVENT, `${prefix}.$..*`, "*", vt.OBJECT),
                //contactId , actorUserId
                ga(contexts.EVENT, `${prefix}.contactId`, "Contact ID", vt.STRING),
                ga(contexts.EVENT, `${prefix}.actorUserId`, "Actor User ID", vt.STRING),
                ga(contexts.EVENT, `${prefix}.sessionId`, "Actor Session ID", vt.STRING),
            ]),
        ];
    }

    adViewed() {
        const e = AutomationEventTypes.CONTACT.AD_VIEWED;
        const ga = this.parent.generateAttribute;

        const prefix = `event.${e}`;
        return [
            ga(contexts.EVENT, `${prefix}`, "Reklam Görüntülendi", vt.OBJECT, undefined, [
                ga(contexts.EVENT, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(contexts.EVENT, `${prefix}.visitorId`, "Visitor ID", vt.STRING),
                ga(contexts.EVENT, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(contexts.EVENT, `${prefix}.sourceType`, "Kaynak Türü", vt.STRING),
                ga(contexts.EVENT, `${prefix}.sourceId`, "Kaynak ID", vt.STRING),
                ga(contexts.EVENT, `${prefix}.sourceLink`, "Kaynak Linki", vt.STRING),
                ga(contexts.EVENT, `${prefix}.headline`, "Başlık", vt.STRING),
                ga(contexts.EVENT, `${prefix}.body`, "İçerik", vt.STRING),
                ga(contexts.EVENT, `${prefix}.adInfo`, "Reklam Bilgileri", vt.OBJECT, undefined, [
                    ga(contexts.EVENT, `${prefix}.adInfo.name`, "Reklam Adı", vt.STRING),
                    ga(contexts.EVENT, `${prefix}.adInfo.account_id`, "Hesap ID", vt.STRING),
                    ga(contexts.EVENT, `${prefix}.adInfo.ad_active_time`, "Reklam Aktif Süresi", vt.STRING),
                    ga(contexts.EVENT, `${prefix}.adInfo.configured_status`, "Yapılandırılmış Durum", vt.STRING),
                    ga(contexts.EVENT, `${prefix}.adInfo.effective_status`, "Etkili Durum", vt.STRING),
                    ga(contexts.EVENT, `${prefix}.adInfo.id`, "Reklam ID", vt.STRING),
                    ga(contexts.EVENT, `${prefix}.adInfo.adset`, "Reklam Seti", vt.OBJECT, undefined, [
                        ga(contexts.EVENT, `${prefix}.adInfo.adset.name`, "Reklam Seti Adı", vt.STRING),
                        ga(contexts.EVENT, `${prefix}.adInfo.adset.id`, "Reklam Seti ID", vt.STRING),
                    ]),
                    ga(contexts.EVENT, `${prefix}.adInfo.campaign`, "Kampanya", vt.OBJECT, undefined, [
                        ga(contexts.EVENT, `${prefix}.adInfo.campaign.name`, "Kampanya Adı", vt.STRING),
                        ga(contexts.EVENT, `${prefix}.adInfo.campaign.id`, "Kampanya ID", vt.STRING),
                    ]),
                ]),
            ]),
        ];
    }
}

export default ContactModuleAttributeFactory;
